<template>
  <div class="squadra_info white--text">
    <div class="squadra-info-crediti">
      <div class="squadra-info-valore">
        <span class="squadra-info-label">Crediti residui</span>
        <crediti :crediti="crediti" use-icon class="squadra-info-importo" />
      </div>
      <div class="squadra-info-valore">
        <span class="squadra-info-label">Offerta massima</span>
        <span class="squadra-info-max">
          <v-icon small color="white">trending_up</v-icon>
          {{ maxofferta }}
        </span>
      </div>
    </div>
    <div class="squadra-info-ruoli">
      <div
        v-for="ruolo in ruoli_array"
        :key="ruolo"
        class="squadra-info-ruolo"
        :style="{ color: `var(--ruolo-${ruolo})` }"
        :title="Constants.RUOLI_NEW[ruolo].plurale"
      >
        <div class="squadra-info-conteggio">
          <span
            class="squadra-info-lettera Ruolo font-weight-bold"
            :class="`Ruolo_${ruolo}`"
          >{{ Constants.RUOLI_NEW[ruolo].abc }}</span>
          <strong>{{ acquistiPerRuolo(ruolo, id_squadra) }}</strong>
          <v-icon
            v-if="acquistiCompletati(ruolo, id_squadra)"
            class="squadra-info-completato"
            :aria-label="`${Constants.RUOLI_NEW[ruolo].plurale}: completati`"
          >check</v-icon>
        </div>
        <div class="squadra-info-limite">
          <template v-if="asta_info.lega.nRuoli.op === 'illimitati'">
            Senza limite
          </template>
          <template v-else>
            {{ prefixAcquistabiliPerRuolo() || 'su' }}
            <strong>{{ acquistabiliPerRuolo(ruolo) }}</strong>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixins from "../../js/mixins";
import Vuex from "vuex";
import Crediti from "./Crediti";

export default {
  name: "squadra-info-panel",
  mixins: [mixins],
  components: { Crediti },
  props: {
    id_squadra: {
      type: String || Number,
      required: true,
      default: null,
    },
  },
  mounted() {},
  computed: {
    crediti: function () {
      return this.asta_squadre[this.id_squadra].crediti;
    },
    maxofferta: function () {
      return this.asta_squadre[this.id_squadra].max_offerta;
    },
    ...Vuex.mapGetters(["asta_info", "asta_squadre"]),
  },
};
</script>
<style scoped>
.squadra_info {
  background: var(--dark_card_bk);
  border-radius: 6px;
  padding: 12px;
  text-align: center;
  width: 100%;
}

.squadra-info-crediti {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  padding-bottom: 10px;
}

.squadra-info-valore {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  min-width: 0;
}

.squadra-info-label {
  font-size: 11px;
  line-height: 1.3;
}

.squadra-info-max {
  background: color-mix(in srgb, currentColor, transparent 87%);
  gap: 4px;
      align-items: center;
    border-radius: 4px;
    display: inline-flex;
    font-size: 11px;
    font-weight: bold;
    justify-content: center;
    padding: 2px 10px;
    white-space: nowrap;
}

.squadra-info-ruoli {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px 4px;
  border-top: 1px solid var(--dark_card_header_bk);
  padding-top: 10px;
}

.squadra-info-ruolo {
  min-width: 0;
}

.squadra-info-conteggio {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-size: 15px;
  line-height: 1.4;
  font-variant-numeric: tabular-nums;
}

.squadra-info-completato {
  color: inherit;
  font-size: 12px;
}

.squadra-info-limite {
  font-size: 10px;
  line-height: 1.4;
  overflow-wrap: anywhere;
}
</style>
